import React from 'react';
import { connect } from 'react-redux';
import MarkUp from '../components/MarkUp';

import { getPrivacyPolicy } from '../redux/modules/user/action';

class PrivacyPolicy extends React.Component {
  state = {
    message: null
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPrivacyPolicy());
  }

  render() {
    const { privacyPolicy } = this.props;
    if (!privacyPolicy || !privacyPolicy.title) {
      return (
        <React.Fragment>
        
        <MarkUp
  html={`

 <h1 style="text-align:center;">RoomerResume Privacy Policy</h1>

  <p style="text-align:center;"><strong>Effective Date:</strong> December 12, 2018</p>

  <br>
  <h2>1. This Privacy Policy Applies to the Sites and Apps Where It Appears.</h2>
  <p>This policy describes how RoomerResume treats personal information. It applies to information we collect on the sites and apps where it is posted. This policy applies to both our tenants (roomers) and our landlords (vacancy providers). It also applies to our roommates (roomers). By interacting with us, you consent to our privacy practices.</p>

  <h2>2. We Collect Personal Information From and About You.</h2>
  <p><strong>We collect contact information.</strong> We collect your name and email address, vacancy addresses, phone number, and social media information.</p>

  <p><strong>We collect rental preferences.</strong> Including move-in dates, length of stay, and preferred location.</p>

  <p><strong>We collect demographic information.</strong> Such as age range, gender, and zip code.</p>

  <p><strong>We collect information you post.</strong> Including photos, videos, and posts.</p>

  <p><strong>We collect payment information.</strong> Including card and billing details.</p>

  <p><strong>We collect device and usage data.</strong> Including IP address and device ID.</p>

  <h2>3. We Collect Information in Different Ways.</h2>
  <p>We collect information directly, passively via technology, and from third parties.</p>

  <h2>4. How We Use Your Information.</h2>
  <p>We use information for communication, improving services, marketing, security, and legal compliance.</p>

  <h2>5. We Combine Information.</h2>
  <p>We may combine information collected online and offline.</p>

  <h2>6. We Share Information in Certain Cases.</h2>
  <p>We share information when required by law or during business transfers.</p>

  <h2>7. Your Choices.</h2>
  <p>You may opt-out of marketing or request updates/deletion of your info.</p>

  <h2>8. Children’s Privacy.</h2>
  <p>We do not knowingly collect data from children under 13.</p>

  <h2>9. Security.</h2>
  <p>We use reasonable safeguards but the internet is not 100% secure.</p>

  <h2>10. Links to Other Sites.</h2>
  <p>We are not responsible for third-party site practices.</p>

  <h2>11. Data Storage.</h2>
  <p>Your data may be processed in the United States.</p>

  <h2>12. California Privacy Rights.</h2>
  <p>California residents may request information regarding data sharing.</p>

  <h2>13. Contact Us.</h2>
  <p>Email: chirp@RoomerResume.com</p>
  <p>RoomerResume.com<br/>534 Marine Ave<br/>Manhattan Beach, CA 90266</p>

  <h2>14. Updates.</h2>
  <p>We may update this privacy policy periodically.</p>

  `}
/>

          <div className="foter">
            <p> Copyright 2019 © RoomerResume. All Rights Reserved.</p>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <h3>{privacyPolicy.title}</h3>
        <MarkUp html={privacyPolicy.description ? privacyPolicy.description : "no data found"}/>
        <div className="foter">
          <p> Copyright 2019 © RoomerResume. All Rights Reserved.</p>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  privacyPolicy: state.user.privacyPolicy
});

export default connect(mapStateToProps)(PrivacyPolicy);